import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomeSec'

Vue.use(VueRouter)

const routes = [
  {
    path: '/adPage',
    name: 'adPage', // // 广告页面
    component: () => import(/* webpackChunkName: "about" */ '../views/ad'),
    meta:{
      title:'全球灯云',
      keepAlive: true, //此组件需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true // 判断页面是否需要登录
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home, // 首页
    meta:{
      title:'全球灯云',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/homeSec',
    name: 'HomeSec', // // 旧版首页
    component: () => import(/* webpackChunkName: "about" */ '../views/Home'),
    meta:{
      title:'全球灯云',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/about',
    name: 'About', // 废弃
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
    }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/User'),
    meta:{
      title:'个人中心',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('../views/order/index'),
    meta:{
      title:'订单',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/orderDes',
    name: 'OrderDes',
    component: () => import('../views/order/des'),
    meta:{
      title:'订单详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/orderComment',
    name: 'orderComment',
    component: () => import('../views/order/comment'),
    meta:{
      title:'评价',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/orderSalesReturn',
    name: 'orderSalesReturn',
    component: () => import('../views/order/orderSalesReturn'),
    meta:{
      title:'申请退货',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/login',
    name: 'Login',// 废弃
    component: () => import(/* webpackChunkName: "about" */ '../views/user/login'),
    meta:{
      title:'登录',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import(/* webpackChunkName: "about" */ '../views/Service'),
    meta:{
      title:'智能客服',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import(/* webpackChunkName: "about" */ '../views/Cart'),
    meta:{
      title:'购物车',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/factoryList',
    name: 'factoryList',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/factoryList'),
    meta:{
      title:'灯饰探厂',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/factoryDes', // 废弃
    name: 'factoryDes',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/factoryDes'),
    meta:{
      title:'灯饰探厂详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/factoryDes2',
    name: 'factoryDes2',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/factoryDes2'),
    meta:{
      title:'灯饰探厂详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/zhiBoList',
    name: 'zhiBoList',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/zhiBoList'),
    meta:{
      title:'全球直播',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/materialList',
    name: 'materialList', // 视频素材模块
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/materialList'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      title:'全球直播',// 视频素材模块
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/zhiBoDes',
    name: 'zhiBoDes',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/zhiBoDes'),
    meta:{
      title:'全球直播间详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  // roomPassword
  {
    path: '/roomPassword',
    name: 'roomPassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/roomPassword'),
    meta:{
      title:'密码验证',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/payComeBack',
    name: 'payComeBack', // 用于直播间礼物支付、红包支付成功后获取直播间id
    component: () => import(/* webpackChunkName: "about" */ '../views/home/payComeBack'),
    meta:{
      title:'支付成功',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/liveDes',
    name: 'liveDes',  //已废弃
    component: () => import(/* webpackChunkName: "about" */ '../views/home/liveDes'),
    meta:{
      title:'详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/liveDes2',
    name: 'liveDes2', // 直播精品视频重播详情
    component: () => import(/* webpackChunkName: "about" */ '../views/home/liveDes2'),
    meta:{
      title:'全球直播间详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/souvenirList',
    name: 'souvenirList',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/souvenirList'),
    meta:{
      title:'中山手信',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/activityTheme/:type', // // 用在中山手信、一些活动商品界面 根据不同的类型获取不同的数据
    name: 'activityTheme',
    component: () => import(/* webpackChunkName: "activityTheme" */ '../views/goods/activityTheme'),
    meta:{
      title:'全球灯云',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/activityThemeSec/:type', // 废弃
    name: 'activityThemeSec',
    component: () => import('../views/goods/activityThemeSec'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/goodDetails',
    name: 'GoodDetails',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/GoodDetails'),
    meta:{
      title:'商品详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/shopDes',
    name: 'ShopDes',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/shopDes'),
    meta:{
      title:'企业详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/orderPay',
    name: 'orderPay',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/orderPay1'),
    meta:{
      title:'订单结算',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/cartPay',
    name: 'cartPay',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/cartPay1'),
    meta:{
      title:'订单结算',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/submitOrder',
    name: 'submitOrder',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/submitOrder'),
    meta:{
      title:'支付订单',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/paySucceed',
    name: 'paySucceed',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/paySucceed'),
    meta:{
      title:'支付完成',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/goodClassify',
    name: 'GoodClassify', //分类
    component: () => import('../views/goods/classify'),
    meta:{
      title:'中山精品',
      requireLogin: true,
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
    }
  },
  {
    path: '/oneYuan',
    name: 'oneYuan',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/oneYuan'),
    meta:{
      title:'1元精品',
      requireLogin: true,
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
    }
  },
  {
    path: '/searchList',
    name: 'searchList',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/searchList'),
    meta:{
      title:'搜索列表',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true,

    }
  },
  {
    path: '/goodList',
    name: 'GoodList',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/list'),
    meta:{
      title:'商品列表',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/couponDes',
    name: 'couponDes',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/couponDes'),
    meta:{
      title:'优惠券详情',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/collectList',
    name: 'collectList',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/collect'),
    meta:{
      title:'我的收藏',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/recharge'),
    meta:{
      title:'充值',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/wallet'),
    meta:{
      title:'会员钱包',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/applyForEdit',
    name: 'applyForEdit',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/applyForEdit'),
    meta:{
      title:'《广东名优企业品牌》提名资格填报',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  // {
  //   path: '/applyFor',
  //   name: 'applyFor',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/user/applyFor'),
  //   meta:{
  //     title:'《广东名优企业品牌》提名资格填报',
  //     keepAlive: false
  //   }
  // },
  {
    path: '/applyForCheck',
    name: 'applyForCheck',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/applyForCheck'),
    meta:{
      title:'《广东名优企业品牌》提名资格填报',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/applyFor',
    name: 'applyFor',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/applyFor'),
    meta:{
      title:'《广东名优企业品牌》提名资格填报',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/brandAuthorization',
    name: 'brandAuthorization',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/brandAuthorization'),
    meta:{
      title:'“古镇灯饰”商标申请授权',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/xieyi',
    name: 'xieyi',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/xieyi'),
    meta:{
      title:'协议',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: false
    }
  },
  {
    path: '/xieYiList',
    name: 'xieYiList',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/xieYiList'),
    meta:{
      title:'协议列表',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: false
    }
  },
  {
    path: '/xieYiDes',
    name: 'xieYiDes',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/xieYiDes'),
    meta:{
      title:'用户协议',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: false
    }
  },
  {
    path: '/shop/:id',
    name: 'shop',
    component: () => import('../views/user/shop'),
    meta:{
      title:'买单',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: false
    }
  },
  {
    path: '/shoper/order/:id/:code',
    name: 'shoperOrder',
    component: () => import('../views/shoper/order'),
    meta:{
      title:'自提核销',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: false
    }
  },
  {
    path: '/billList',
    name: 'billList',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/billList'),
    meta:{
      title:'支付账单',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/agreement'),
    meta:{
      title:'平台协议',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/bindingCard',
    name: 'bindingCard',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/burse/bindingCard'),
    meta:{
      title:'绑定银行卡',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/myCard',
    name: 'myCard', // 我的银行卡
    component: () => import(/* webpackChunkName: "about" */ '../views/user/burse/myCard'),
    meta:{
      title:'全球灯云',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/openBurse',
    name: 'openBurse', // 开通钱包
    component: () => import(/* webpackChunkName: "about" */ '../views/user/burse/openBurse'),
    meta:{
      title:'全球灯云',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/withdrawDeposit',
    name: 'withdrawDeposit',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/burse/withdrawDeposit'),
    meta:{
      title:'粤精品',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/contactUs'),
    meta:{
      title:'联系我们',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/classifyList',
    name: 'classifyList',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/classifyList'),
    meta:{
      title:'商品列表',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/traceGoodsSpecification/:id',// 查询商品编码，查询结果为官方授权的产品
    name: 'traceGoodsSpecification',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/goodsSpecification'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true,
      title:'商品详情',
    }
  },
  {
    path: '/addressList',
    name: 'addressList',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/addressList'),
    meta:{
      title:'地址列表',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/selectAddress',
    name: 'selectAddress',
    component: () => import(/* webpackChunkName: "about" */ '../views/goods/selectAddress'),
    meta:{
      title:'地址列表',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/addressEdit',
    name: 'addressEdit',
    component: () => import('../views/user/addressEdit'),
    meta:{
      title:'编辑地址',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/consumerLogin',
    name: 'consumerLogin',
    component: () => import('../views/consumer/login'),
    meta: {
      requireLogin: true,
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
    }
  },
  {
    path: '/consumerRegister',
    name: 'consumerRegister',
    component: () => import('../views/consumer/register'),
    meta: {
      requireLogin: true,
      title:'中山通会卡注册',
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
    }
  },
  {
    path: '/test',
    name: 'test', // 测试界面
    component: () => import('../views/home/test'),
    meta: {
      requireLogin: true,
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
    }
  },
  {
    path: '/discountCoupon',
    name: 'discountCoupon', // 我的优惠券界面
    component: () => import('../views/goods/discountCoupon'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      requireLogin: true
    }
  },
  {
    path: '/indexBusiness',
    name: 'indexBusiness',
    component: () => import('../views/merchant/indexBusiness'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      title:'商家运营中心',
      requireLogin: true
    }
  },
  {
    path: '/userBusiness',
    name: 'userBusiness',
    component: () => import('../views/merchant/userBusiness'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      title:'商家运营个人中心',
      requireLogin: true
    }
  },
  {
    path: '/scanBusiness',
    name: 'scanBusiness',
    component: () => import('../views/merchant/scan'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      title:'扫一扫',
      requireLogin: true
    }
  },
  {
    path: '/registerCode',
    name: 'registerCode',
    component: () => import('../views/user/registerCode'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      title:'快码推广',
      requireLogin: true
    }
  },
  {
    path: '/polyCode',
    name: 'polyCode',
    component: () => import('../views/user/polyCode'),
    meta:{
      keepAlive: false, //此组件不需要被缓存
      isBack:false, //用于判断上一个页面是哪个
      title:'快码申请',
      requireLogin: true
    }
  }
]
// 解决 Failed to resolve async component default: TypeError: Cannot read property '1' of undefined
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const router = new VueRouter({
  routes,
  mode:'history',
  scrollBehavior(to,from,savePosition){ // // 在点击浏览器的“前进/后退”，或者切换导航的时候触发
    if(savePosition){  // to：要进入的目标路由对象，到哪里去  // // from：离开的路由对象，哪里来
      //解决页面从列表页跳转到详情页返回,初始在原来位置
      return savePosition // / savePosition：会记录滚动条的坐标，点击前进/后退的时候记录值{x:?,y:?}
    }else{
      //解决页面跳转后页面高度和前一个页面高度一样
      return {x:0,y:0}
    }
  }
})

export default router
